import type { FC } from 'react';

import { cn } from '@repo/utils/common';

import { APP_BAR_HEIGHT_CLASS } from '@/shared/configs/toolbar.config';

import { Container } from '@/components/common/Container';
import { LanguageSelect } from '@/components/common/LanguageSelect';
import { UserButton } from '@/components/common/UserButton';
import { WarrantyLink } from '@/components/toolbar/WarrantyLink';

export const AppBar: FC = () => (
  <div className="bg-muted text-black">
    <Container className={cn('flex items-center justify-between', APP_BAR_HEIGHT_CLASS)}>
      <WarrantyLink />
      <div className="flex items-center gap-1">
        <LanguageSelect />
        <UserButton />
      </div>
    </Container>
  </div>
);
